import React from 'react';
import { LocalServicePage } from '../../components/LocalServicePage';

export const LocksmithChelmsford = () => {
  return (
    <LocalServicePage
      areaName="Chelmsford"
      areaType="City"
      slug="locksmith-chelmsford"
      heroTitle="Door, Window & Lock Repairs in Chelmsford"
      heroSubtitle="Royal Security provides door, window, and lock repair services in Chelmsford and the surrounding Essex area. We offer both emergency attendance and planned appointments—contact us to confirm availability for your situation."
      introContent={
        <>
          <p style={{ fontSize: '1.1rem', lineHeight: '1.8', marginBottom: '20px', color: 'var(--text-secondary)' }}>
            Chelmsford is part of our Essex coverage area. We're based in Romford rather than Chelmsford itself, but we regularly travel to the city for both urgent repairs and scheduled work. Contact us to discuss your requirements and confirm our availability.
          </p>
          <p style={{ fontSize: '1.1rem', lineHeight: '1.8', marginBottom: '20px', color: 'var(--text-secondary)' }}>
            We offer emergency attendance and planned appointments in Chelmsford. For urgent situations—doors that won't lock, security issues, or repairs that can't wait—contact us and we'll confirm when we can attend. For planned work like glazing replacements, mechanism overhauls, or multiple repairs, we'll arrange a convenient appointment time.
          </p>
          <p style={{ fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--text-secondary)' }}>
            When you contact us, we'll ask about the problem, discuss what's involved, and give you an honest assessment of when we can attend. We don't promise fixed arrival times we can't keep—we'd rather give you a realistic timeframe and stick to it.
          </p>
        </>
      }
      servicesEmphasis={[
        {
          title: "Multipoint Lock Repairs",
          description: "We diagnose and repair multipoint locking systems on composite and uPVC doors. Whether it's gearbox replacement, hook and roller renewal, or complete mechanism fitting, we identify the fault and fix it properly."
        },
        {
          title: "Glazing Repairs & Replacements",
          description: "Failed sealed units, misted double glazing, and cracked panes are problems we resolve regularly. We replace glass within existing frames, with options for upgraded thermal or acoustic performance if you want better insulation."
        },
        {
          title: "Door Realignment & Adjustment",
          description: "Doors that drag, stick, or won't close properly often need realignment rather than replacement. We adjust hinges, reposition strike plates, and ensure your door closes smoothly and locks securely."
        },
        {
          title: "Window Mechanism Repairs",
          description: "Tilt and turn windows, casement windows, and other systems can develop faults with their hardware. We repair or replace friction stays, espagnolettes, tilt mechanisms, handles, and locking points."
        },
        {
          title: "uPVC & Composite Door Repairs",
          description: "We handle all aspects of door repairs—locks, handles, hinges, letterboxes, weather seals, and panels. If your door isn't working properly, we'll diagnose the cause and fix it."
        },
        {
          title: "Security Improvements",
          description: "If you're looking to upgrade your door or window security, we can assess what you have and recommend practical improvements—better locks, upgraded hardware, or additional security features."
        }
      ]}
      localContextTitle="Planning a Repair Visit in Chelmsford"
      localContext={
        <>
          <p style={{ fontSize: '1.05rem', lineHeight: '1.8', marginBottom: '20px', color: 'var(--text-secondary)' }}>
            Chelmsford has a mix of property types—from period homes around the city centre to newer developments on the outskirts. Each brings different door and window systems, and we work on all of them.
          </p>
          <p style={{ fontSize: '1.05rem', lineHeight: '1.8', marginBottom: '20px', color: 'var(--text-secondary)' }}>
            The travel distance from our base means we plan our Chelmsford visits carefully. For involved work—multiple window repairs, glazing replacements, or comprehensive door overhauls—we allocate sufficient time to complete the job properly in one visit where possible.
          </p>
          <p style={{ fontSize: '1.05rem', lineHeight: '1.8', color: 'var(--text-secondary)' }}>
            Some repairs require parts that need ordering. We'll tell you upfront if this applies to your job, so you know whether we can complete the repair immediately or need to return once parts arrive.
          </p>
        </>
      }
      commonProblems={[
        {
          title: "Door won't lock or unlock properly",
          description: "Usually a gearbox, alignment, or cylinder issue. We diagnose whether adjustment, part replacement, or mechanism change is needed."
        },
        {
          title: "Misted or foggy double glazing",
          description: "The seal has failed between panes. We measure and replace the sealed unit within your existing frame."
        },
        {
          title: "Window stuck open or closed",
          description: "Mechanism or hinge failure. We repair or replace the specific hardware at fault."
        },
        {
          title: "Draughts around doors or windows",
          description: "Worn seals, dropped hinges, or frames needing adjustment. Often a straightforward fix."
        },
        {
          title: "Handle broken or hard to turn",
          description: "We replace handles and internal mechanisms to restore smooth operation."
        },
        {
          title: "Patio or bi-fold door not running smoothly",
          description: "Rollers, tracks, and alignment all affect operation. We service and repair these systems."
        }
      ]}
      whyChooseUs={
        <>
          <p style={{ fontSize: '1.05rem', lineHeight: '1.8', marginBottom: '20px', color: 'var(--text-secondary)' }}>
            We're straightforward about what we can offer in Chelmsford. We're based in Romford, not locally, so contact us to confirm availability. We offer both emergency attendance and planned appointments—we'll give you an honest assessment of when we can attend.
          </p>
          <p style={{ fontSize: '1.05rem', lineHeight: '1.8', marginBottom: '20px', color: 'var(--text-secondary)' }}>
            Our diagnosis-first approach applies regardless of location. We identify the actual problem before starting work, explain your options clearly, and only do what's necessary to fix the issue properly.
          </p>
          <p style={{ fontSize: '1.05rem', lineHeight: '1.8', color: 'var(--text-secondary)' }}>
            If you're in Chelmsford and need door, window, or lock repairs, call us to discuss your situation. We'll tell you honestly what we can do and when we can do it.
          </p>
        </>
      }
      ctaText="Need Door or Window Repairs in Chelmsford?"
    />
  );
};
